import styles from './ScriptText.module.css';

interface ScriptTextProps {
  children: React.ReactNode;
  glow?: boolean;
  rotate?: number;
  className?: string;
  as?: 'span' | 'div';
}

export function ScriptText({ children, glow = true, rotate = 0, className = '', as: Tag = 'span' }: ScriptTextProps) {
  return (
    <Tag
      className={`${styles.script} ${glow ? styles.glow : ''} ${className}`}
      style={rotate ? { transform: `rotate(${rotate}deg)`, display: 'inline-block' } : undefined}
    >
      {children}
    </Tag>
  );
}
